export class CfetMessagesConstant {
        public static CFET_MESSAGES = {
                first_name_error: 'Enter valid first name with minimum 2 characters',
                last_name_error: 'Enter valid last name with minimum 2 characters',
                valid_email: 'Be sure your email address is in this format: name@domain.com',
                valid_emailAddress: 'Enter valid email format',
                emailAlreadyExists: 'This email address is already linked to an AT&T profile. Please enter a different email address.',
                empty_emailAddress: 'Please enter valid email ID',
                empty_email: 'Please enter/change the value',
                mobile_number_error: `Be sure you've entered your 10-digit phone number`,
                dob_error: 'Be sure you enter your date of birth in this format: mm/dd/yyyy',
                personal_info_ineligible: 'Ineligible',
                personal_info_dob_error: 'Ineligible. Minimum age required is 16 years',
                Org_name_error: 'Enter valid organization name with minimum 2 characters',
                address_line: 'Address line 1 should have minimum 2 characters',
                city: 'City should have minimum 2 characters',
                state: 'Select a state',
                email_id_asUser_id: 'This email address will be your ID to sign in to FirstNet and My AT&T when you get mobility service.',
                valid_zipcode: 'Be sure to enter your 5-digit ZIP code',
                valid_employee_id: 'Employee Id should have minimum 1 character',
                return_to_landing_page: 'FirstNet Landing Page',
                off_doc_file_error: 'File type not valid',
                off_doc_file_error_desc: 'Upload a valid file type. You can upload the following file types: BMP, GIF, JPG, PNG, or PDF.',
                password_mismatch: 'Be sure to enter the same password in both password fields',
                security_minlenth_three: 'Security answer should have minimum 3 characters',
                email_exists1: 'An account with this email already exists. Please ',
                email_exists2: ' or use a different email',
                pd_rule_title1_new: 'Enter a password with at least:',
                lengthRule: '8 characters',
                capitalLetterRule: '1 uppercase letter',
                smallLetterRule: '1 lowercase letter',
                numRule: '1 number',
                valid_employeeID: 'Enter a valid Employee ID of at least 4 characters',
                valid_password: 'Enter a valid password.',
                strong_password: 'Enter a stronger password.',
                otp_code_expired: `Your code expired. Click <b>Resend code</b> and try again.`,
                pd_rule_title2: 'Your password can’t be commonly used,<br>such as Password!123. It also can’t<br>contain your user ID or:',
                pd_rule_title2_mobile: 'Your password can’t be commonly used, such as Password!123. It also can’t contain your user ID or:',
                length24: 'More than 24 characters',
                repeating3: '3 or more repeating characters',
                sequence3: 'A sequence of 3 or more characters,<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;such as 4321 or ABC',
                specialCharsRule: '1 special character <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;(standard U.S. keyboard)',
                affiliation_code_error: `The code is not valid, please check it and try again`,
                email_in_att: 'Email address belongs to an AT&T ID',
                email_att_already_used: 'Please restart the process and link your FirstNet and AT&T IDs, or use a different email address for Firstnet.',
                official_doc_system_error: 'Something went wrong. Please try again or come back later.'
        };
}
